import React from 'react';
import { FAQSection } from '../components/FAQSection';
import { ContactSection } from '../components/ContactSection';
export function Contact() {
  return <div data-id="element-871">
      <ContactSection data-id="element-872" />
      <FAQSection data-id="element-873" />
    </div>;
}